import type { Kandidat } from './typen';

/**
 * Trennt die Kandidaten in „bekommt eine Mail" und „steht auf der Druckliste".
 *
 * Zwei Feinheiten, die im Bestand wirklich vorkommen:
 * - Ehepaare teilen sich haeufig EINE Adresse. Wer zweimal dieselbe Adresse hat, bekommt
 *   trotzdem nur eine Mail — sonst liegt das Rundschreiben doppelt im Postfach.
 * - Wer keine Adresse hat, faellt nicht weg, sondern wechselt in die andere Liste.
 *   299 von 683 aktiven Mietern betrifft das; sie stillschweigend zu verlieren waere
 *   die schlimmste Variante.
 */
export function teileAuf(kandidaten: Kandidat[]): { erreichbar: Kandidat[]; ohneAdresse: Kandidat[]; doppelt: number } {
  const erreichbar: Kandidat[] = [];
  const ohneAdresse: Kandidat[] = [];
  const schonDrin = new Set<string>();
  // Abschluss-Review I10: die Uebersprungenen zaehlen. Vorher fielen sie aus BEIDEN Listen
  // heraus — „erreichbar + ohne Adresse" deckte dann nicht mehr alle aktiven Mieter ab, und
  // die Differenz war von der Oberflaeche aus nicht erklaerbar. Als drittes Feld ergaenzt,
  // damit vorhandene Aufrufer unveraendert weiterlaufen.
  let doppelt = 0;
  for (const kandidat of kandidaten || []) {
    if (!kandidat.email) { ohneAdresse.push(kandidat); continue; }
    const schluessel = kandidat.email.trim().toLowerCase();
    if (schonDrin.has(schluessel)) { doppelt++; continue; }
    schonDrin.add(schluessel);
    erreichbar.push(kandidat);
  }
  return { erreichbar, ohneAdresse, doppelt };
}
